import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedFetch } from './useAuthenticatedFetch';
import { API_URL } from '../utils/config';
import { 
  createKeyFindingsQueryConfig,
  createKeyInsightsQueryConfig,
  type KeyFindingsResponse,
  type KeyInsightsResponse,
  type UseKeyInsightsParams
} from '@horwath-htl/shared-ui';

// Create query config with private-web configuration
const getQueryConfig = (authenticatedFetch: any) => {
  const keyFindingsConfig = createKeyFindingsQueryConfig({ 
    apiUrl: API_URL, 
    authenticatedFetch 
  });
  
  const keyInsightsConfig = createKeyInsightsQueryConfig({ 
    apiUrl: API_URL, 
    authenticatedFetch 
  });
  
  return { keyFindingsConfig, keyInsightsConfig };
};

export const useKeyFindings = (reportId: number) => {
  const { authenticatedFetch } = useAuthenticatedFetch();
  const { keyFindingsConfig } = getQueryConfig(authenticatedFetch);
  return useQuery<KeyFindingsResponse>(keyFindingsConfig.getKeyFindings(reportId));
};

export const useMarketKeyFindings = (marketId: number, months: number = 12) => {
  const { authenticatedFetch } = useAuthenticatedFetch();
  const { keyFindingsConfig } = getQueryConfig(authenticatedFetch);
  return useQuery<KeyFindingsResponse>(keyFindingsConfig.getMarketKeyFindings(marketId, months));
};

export const useKeyInsights = (params: UseKeyInsightsParams) => {
  const { authenticatedFetch } = useAuthenticatedFetch();
  const { keyInsightsConfig } = getQueryConfig(authenticatedFetch);
  return useQuery<KeyInsightsResponse>(keyInsightsConfig.getKeyInsights(params));
};